import React from 'react';
import {
  PieChart,
  ShoppingCart,
  Business,
  Poll,
  Chat,
  BlurCircular,
  Group,
  FolderShared,
  VerifiedUser,
} from '@material-ui/icons';
import { makeURL } from '../../../../../helperFunctions';
import { subscriptionTypeNames } from '../../../../../config/subscriptionsConfig';

export const getSidebarItems = (isCompany, isAdmin) => {
  const baseItems = [
    {
      type: 'section',
      restrictedSubscriptions: [],
      children: [
        {
          name: 'Brand Personas',
          type: 'item',
          icon: <PieChart />,
          link: makeURL('/brand-personas/all'),
        },
      ],
    },
    {
      type: 'section',
      restrictedSubscriptions: [],
      children: [
        {
          name: 'Buyer Personas',
          type: 'item',
          icon: <ShoppingCart />,
          link: makeURL('/buyer-personas/all'),
        },
      ],
    },
    {
      type: 'section',
      restrictedSubscriptions: [],
      children: [
        {
          name: 'Marketing Dashboard',
          type: 'item',
          icon: <BlurCircular />,
          link: makeURL('/marketing-content/all'),
        },
      ],
    },
    {
      type: 'section',
      restrictedSubscriptions: [],
      children: [
        {
          name: 'Consumer Dashboard',
          type: 'item',
          icon: <Business />,
          link: makeURL('/consumer-dash'),
        },
      ],
    },
    {
      type: 'section',
      restrictedSubscriptions: [subscriptionTypeNames.demo],
      children: [
        {
          name: 'Competitive Set Brands',
          type: 'item',
          icon: <Poll />,
          link: makeURL('/competitive-set-brands/all'),
        },
      ],
    },
    {
      type: 'section',
      restrictedSubscriptions: [
        subscriptionTypeNames.academic,
        subscriptionTypeNames.standard,
        subscriptionTypeNames.advanced,
        subscriptionTypeNames.demo,
      ],
      children: [
        {
          name: 'Your Brand & Consumers',
          type: 'item',
          icon: <Group />,
          link: makeURL('/brand-consumers/all'),
        },
      ],
    },
  ];

  // Clients
  if (isCompany) {
    baseItems.push({
      type: 'section',
      restrictedSubscriptions: [],
      children: [
        {
          name: 'Clients',
          type: 'item',
          icon: <FolderShared />,
          link: makeURL('/clients/all'),
        },
      ],
    });
  }

  if (isAdmin) {
    baseItems.push({
      type: 'section',
      restrictedSubscriptions: [
        subscriptionTypeNames.academic,
        subscriptionTypeNames.standard,
        subscriptionTypeNames.advanced,
        subscriptionTypeNames.demo,
        subscriptionTypeNames.enterprise_1000,
        subscriptionTypeNames.enterprise_unlimited,
      ],
      children: [
        {
          name: 'Admin',
          type: 'item',
          icon: <VerifiedUser />,
          link: makeURL('/all-mighty-admin'),
        },
      ],
    });
  }

  //Contact us
  baseItems.push({
    type: 'section',
    restrictedSubscriptions: [],
    children: [
      {
        name: 'Contact Us',
        type: 'item',
        icon: <Chat />,
        link: 'https://www.brandsocialvalue.com/contact/',
      },
    ],
  });

  return baseItems;
};
